<template>
    <b-modal title="Speaker Sub-Section Type"
             size="md"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>
        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <div ref="inputFields">
            <b-form-row>
                <b-form-group label="Sub-Section Type"
                              label-for="subSectionType"
                              class="col-md-8"
                              v-if="subSectionTypeOptions">
                    <b-form-radio-group name="subSectionType"
                                        v-model="subSectionType"
                                        stacked autofocus>
                        <template v-for="(subSectionTypeOption, index) in subSectionTypeOptions">
                            <vue-keypress key-event="keydown"
                                          :key-code="subSectionTypeOption.shortcut.keyCode"
                                          :modifiers="subSectionTypeOption.shortcut.modifiers"
                                          :preventDefault="true"
                                          @success="subSectionType = subSectionTypeOption.value"
                                          :key="'keypress' + index"
                                          v-if="subSectionTypeOption.shortcut"></vue-keypress>
                            <b-form-radio :value="subSectionTypeOption.value" :key="'subsectiontypeoption' + index">
                                {{ subSectionTypeOption.text }}
                                <template v-if="subSectionTypeOption.shortcut">
                                    ({{ subSectionTypeOption.shortcut.text }})
                                </template>
                            </b-form-radio>
                        </template>
                    </b-form-radio-group>
                </b-form-group>
            </b-form-row>
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeSpeakerSubsectionDialog',
        mixins: [EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: this.configuration,
                currentErrors: null,
                showErrors: false,
                subSectionType: null,
                
                sectionsInsertedEventData: null,
                sectionUpdated: false
            }
        },
        computed: {
            subSectionTypeOptions: function () {
                if (this.currentConfiguration == null) return null;
                return this.currentConfiguration.SubSectionTypeOptions;
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        this.subSectionType = $(this.currentEditorSection).data('sub-type')
                    } else {
                        this.subSectionType = null;
                    }
                    this.sectionsInsertedEventData = null;
                    this.sectionUpdated = false;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.subSectionType = null;
                this.currentErrors = null;
            },
            insert: function () {
                this.currentErrors = []
                var marginText = null;
                if  (this.subSectionType == 'question') {
                    marginText = 'Q.';
                } else if (this.subSectionType == 'answer') {
                    marginText = 'A.';
                } else if (this.subSectionType == 'answer-witness') {
                    marginText = 'A. WITNESS:';
                } else if (this.subSectionType == 'answer-interpreter') {
                    marginText = 'A. INTERPRETER:';
                } else if (this.subSectionType == 'answer-examinee') {
                    marginText = 'A. EXAMINEE:';
                } else if (this.subSectionType != 'statement') {
                    this.currentErrors.push('A sub-section type has to be selected');
                }
                if (this.currentErrors.length == 0) {
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var speakerSubSection = null;
                        if (this.mode == 'edit') {
                            speakerSubSection = $(this.currentEditorSection);
                            speakerSubSection
                                .attr('data-sub-type', this.subSectionType)
                                .data('sub-type', this.subSectionType) //IMPORTANT! we need to update both, the data-* attribute and the .data entry, because one is the actual HTML that is read by the server and one is the data that jquery stores internally
                                .removeAttr('data-margintext')
                                .removeData('margintext'); //IMPORTANT! we need to remove both, the data-* attribute and the .data entry, because one is the actual HTML that is read by the server and one is the data that jquery stores internally
                            $('.speaker-subsection-margintext', speakerSubSection).remove(); //remove the old margin text, a new one will be inserted later
                            this.sectionUpdated = true;
                        } else {
                            speakerSubSection =
                                $('<div data-type="speaker-subsection"/>')
                                    .attr('data-sub-type', this.subSectionType)
                                    .attr('id', newUuid());
                            if ($(this.currentEditorSection).data('type') == "speaker-subsection") {
                                speakerSubSection.insertAfter(this.currentEditorSection);
                            } else {
                                var speakerNameNode = $('.speaker-name', $(this.currentEditorSection));
                                if (speakerNameNode && speakerNameNode.length) speakerSubSection.insertAfter(speakerNameNode[0]);
                                else speakerSubSection.appendTo(this.currentEditorSection);
                            }
                            var insertPosition = $('<p><br/></p>').appendTo(speakerSubSection)[0];
                            this.sectionsInsertedEventData = { sections: [speakerSubSection[0]], insertPosition: insertPosition };
                        }
                        if (marginText != null) {
                            speakerSubSection
                                .attr('data-margintext', marginText)
                                .data('margintext', marginText);
                        }
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else if (this.sectionUpdated) {
                    this.$emit('sectionUpdated');
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
                this.sectionUpdated = false;
            }
        }
    }
</script>
